import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/esm/objectWithoutProperties";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from '@govhhs/govhhs-design-system-react';
/**
 * This component is responsible for providing a wrapper to the WDS Alert which is used as the toast implementation.
 */

var Toast = function Toast(props) {
  var onDismiss = props.onDismiss,
      text = props.text,
      children = props.children,
      rest = _objectWithoutProperties(props, ["onDismiss", "text", "children"]);

  return /*#__PURE__*/React.createElement(Alert, _extends({
    banner: true,
    center: true,
    onDismiss: onDismiss,
    text: text,
    toast: true
  }, rest), children);
};
/**
 * Provides an extension for custom toast notifications by providing the required Web Design System Alert component toast props by default.
 * @param {Component} children The child components to be wrapped in the Alert. It is optional.
 * @param {string} text A message that will appear in the toast notification. This can also be provided by child components. It is optional.
 */


export default Toast;
Toast.defaultProps = {
  children: null,
  onDismiss: function onDismiss() {},
  text: ''
};
Toast.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  onDismiss: PropTypes.func,
  text: PropTypes.string
} : {};